// WAI-ARIAのtablist/tab/tabpanelをクリックと左右キーで切り替える。
//
// ============================================
// HTML 構造例:
// ============================================
// <div class="js-tab">
//   <ul class="js-tab__trigger" role="tablist">
//     <li class="js-tab__trigger-item" role="tab">タブ1</li>
//   </ul>
//   <div class="js-tab__content-item" role="tabpanel">パネル1</div>
// </div>
// ============================================
// CSS 注意:
// is-active / is-open 等の表示・トランジションは CSS 側で定義する。

import { bindOnce } from '../utils/bindOnce';

const CONFIG = {
  groupSelector: '.js-tab',                  // タブグループの外側ラッパー
  triggerListSelector: '.js-tab__trigger',   // tablist
  tabSelector: '.js-tab__trigger-item',      // 各タブボタン
  panelSelector: '.js-tab__content-item',    // 各タブパネル
};

// ページ内の全タブグループを初期化する
function tabFunc() {
  const groups = document.querySelectorAll(CONFIG.groupSelector);
  if (groups.length === 0) return;

  groups.forEach((group) => initTabGroup(group));
}

// 1 つのタブグループを初期化する
function initTabGroup(group) {
  const tabList = group.querySelector(CONFIG.triggerListSelector);
  const tabs    = Array.from(group.querySelectorAll(CONFIG.tabSelector));
  const panels  = Array.from(group.querySelectorAll(CONFIG.panelSelector));

  if (!tabList || tabs.length === 0 || panels.length === 0) return;

  bindClickEvents(tabs, panels);
  bindKeyEvents(tabList, tabs, panels);
}

// クリックでタブを切り替える
function bindClickEvents(tabs, panels) {
  tabs.forEach((tab) => {
    if (!bindOnce(tab, 'tabClick')) return;

    tab.addEventListener('click', () => {
      if (tab.getAttribute('aria-selected') === 'true') return;

      activateTab(tab, tabs, panels);
    });
  });
}

// ←→ キーでタブを移動する
function bindKeyEvents(tabList, tabs, panels) {
  if (!bindOnce(tabList, 'tabKey')) return;

  tabList.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;

    e.preventDefault();

    // インデックスを変数で保持するとクリック切り替え時に起点がずれるため、
    // 毎回 DOM の実際のフォーカス位置から算出する
    let tabFocus = tabs.indexOf(document.activeElement);
    if (tabFocus === -1) {
      tabFocus = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      if (tabFocus === -1) tabFocus = 0;
    }

    // 端に達したら折り返す
    if (e.key === 'ArrowLeft') {
      tabFocus = tabFocus <= 0 ? tabs.length - 1 : tabFocus - 1;
    } else {
      tabFocus = tabFocus >= tabs.length - 1 ? 0 : tabFocus + 1;
    }

    activateTab(tabs[tabFocus], tabs, panels);
    tabs[tabFocus].focus();
  });
}

// タブを切り替えるコアロジック
function activateTab(targetTab, tabs, panels) {
  // tabindex="-1" でキーボードのフォーカス順から外す
  tabs.forEach((tab) => {
    tab.setAttribute('aria-selected', 'false');
    tab.setAttribute('tabindex', '-1');
  });

  targetTab.setAttribute('aria-selected', 'true');
  targetTab.setAttribute('tabindex', '0');

  const targetPanelId = targetTab.getAttribute('aria-controls');
  panels.forEach((panel) => {
    if (panel.id === targetPanelId) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  });
}

export { tabFunc };
